(() => {
  'use strict';
  const root = () => window.Shopify?.routes?.root || window.DLM?.root || '/';
  const drawer = () => document.getElementById('CartDrawer');
  let cartBusy = false;
  const formatMoney = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || window.DLM?.currency || 'USD' }).format(cents / 100);
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }
  function report(message) {
    const target = document.querySelector('[data-cart-error]');
    if (target) { target.textContent = message; target.hidden = !message; }
  }
  async function request(path, options) {
    const response = await fetch(root() + path, { credentials: 'same-origin', ...options });
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : 'Your bag could not be updated. Please try again.');
    return result;
  }
  function safePath(url) {
    try { const parsed = new URL(url, window.location.origin); return parsed.origin === window.location.origin ? parsed.pathname + parsed.search : root() + 'cart'; } catch { return root() + 'cart'; }
  }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    const lines = document.querySelector('[data-cart-lines]');
    if (!lines) return;
    lines.replaceChildren();
    if (!cart.items.length) {
      const empty = element('div', 'empty-cart');
      empty.append(element('h3', '', 'A little room for something good.'), element('p', '', 'Your bag is empty. Let’s find your next table favorite.'));
      const link = element('a', 'button', 'Explore the launch edit'); link.href = root() + 'collections/all'; empty.append(link); lines.append(empty);
    }
    for (const item of cart.items) {
      const row = element('div', 'cart-line');
      const imageLink = element('a'); imageLink.href = safePath(item.url);
      if (item.image) {
        const img = element('img');
        try { const url = new URL(item.image, location.origin); if (url.protocol === 'https:' || url.protocol === 'http:') img.src = url.href; } catch { /* Text remains usable without an image. */ }
        img.alt = item.product_title; img.width = 75; img.height = 75; imageLink.append(img);
      }
      const info = element('div'); const title = element('a', 'cart-line-title', item.product_title); title.href = safePath(item.url); info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(element('small', '', item.variant_title));
      const controls = element('div', 'quantity-control');
      for (const [label, text, quantity] of [['Decrease quantity', '−', item.quantity - 1], ['Increase quantity', '+', item.quantity + 1], ['Remove item', 'Remove', 0]]) {
        const button = element('button', quantity === 0 ? 'remove-button' : '', text); button.type = 'button'; button.setAttribute('aria-label', label + ': ' + item.product_title); button.dataset.cartKey = item.key; button.dataset.cartQuantity = quantity;
        controls.append(button);
        if (text === '−') controls.append(element('span', '', item.quantity));
      }
      info.append(controls); row.append(imageLink, info, element('strong', '', formatMoney(item.final_line_price, cart.currency))); lines.append(row);
    }
    const total = document.querySelector('[data-cart-total]'); if (total) total.hidden = !cart.item_count;
    const subtotal = document.querySelector('[data-cart-subtotal]'); if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);
  }
  async function openBag() {
    const dialog = drawer(); if (!dialog || !dialog.showModal) { window.location.assign(root() + 'cart'); return; }
    if (!dialog.open) dialog.showModal();
    report('');
    try { renderCart(await request('cart.js')); } catch (error) { report(error.message); }
  }
  async function changeItem(key, quantity) {
    if (cartBusy) return; cartBusy = true; report('');
    drawer()?.querySelectorAll('button[data-cart-key]').forEach(button => { button.disabled = true; });
    try { renderCart(await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) })); }
    catch (error) { report(error.message); }
    finally { cartBusy = false; drawer()?.querySelectorAll('button[data-cart-key]').forEach(button => { button.disabled = false; }); }
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const toggle = target.closest('[data-menu-toggle]');
    if (toggle) { const nav = document.getElementById(toggle.getAttribute('aria-controls')); const expanded = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(expanded)); toggle.setAttribute('aria-label', expanded ? 'Close navigation' : 'Open navigation'); nav?.classList.toggle('mobile-open', expanded); }
    if (!target.closest('.nav-submenu')) document.querySelectorAll('[data-navigation-details][open]').forEach(details => { details.open = false; });
    if (!target.closest('.header')) { document.getElementById('MainNavigation')?.classList.remove('mobile-open'); const menu = document.querySelector('[data-menu-toggle]'); menu?.setAttribute('aria-expanded', 'false'); menu?.setAttribute('aria-label', 'Open navigation'); }
    const open = target.closest('[data-open-cart]');
    if (open && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey) { event.preventDefault(); openBag(); }
    if (target.closest('[data-close-cart]')) drawer()?.close();
    const change = target.closest('[data-cart-key]'); if (change) changeItem(change.dataset.cartKey, Number(change.dataset.cartQuantity));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') { const details = event.target.closest?.('[data-navigation-details][open]'); if (details) { details.open = false; details.querySelector('summary')?.focus(); } else { const nav = document.getElementById('MainNavigation'); const wasOpen = nav?.classList.contains('mobile-open'); nav?.classList.remove('mobile-open'); const menu = document.querySelector('[data-menu-toggle]'); menu?.setAttribute('aria-expanded', 'false'); menu?.setAttribute('aria-label', 'Open navigation'); if (wasOpen) menu?.focus(); } }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-product-form]')) return;
    if (window.DLM?.previewOnly || form.dataset.testOnly === 'true' || form.dataset.previewOnly === 'true') { event.preventDefault(); return; }
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]'); if (button?.disabled) return;
    const original = button?.textContent; if (button) { button.disabled = true; button.textContent = 'Adding to your bag…'; }
    const errorTarget = form.querySelector('[data-product-error], [data-product-form-status]'); if (errorTarget) { errorTarget.textContent = ''; errorTarget.hidden = true; }
    try { await request('cart/add.js', { method: 'POST', body: new FormData(form) }); await openBag(); }
    catch (error) { if (errorTarget) { errorTarget.textContent = error.message; errorTarget.hidden = false; } else { window.location.assign(root() + 'cart'); } }
    finally { if (button) { button.disabled = false; button.textContent = original; form.dispatchEvent(new Event('dlm:cart-complete')); } }
  });
  document.addEventListener('shopify:section:load', () => { window.dispatchEvent(new Event('dlm:section-load')); });
})();
